/**
 * Data-mode flag — Story V10-J (web wiring, core screens).
 *
 * 'live' → query hooks fetch the real apps/api endpoints via lib/api-client.
 * 'mock' → query hooks resolve the feature mock modules (UI renders standalone,
 *          no backend required — the pre-V10-J behaviour, kept as the fallback).
 *
 * Resolution order:
 *   1. VITE_DATA_MODE env override ('live' | 'mock') — set VITE_DATA_MODE=live
 *      in dev to exercise the real backend (demo tenant: packages/db/README-SEED.md).
 *   2. Default: production builds → 'live'; dev + vitest → 'mock'.
 *
 * Read at query time (function, not a module constant) so tests can stub the
 * env per-case via vi.stubEnv.
 *
 * [Source: apps/web/src/lib/api-client.ts] (VITE_API_BASE_URL env precedent)
 * [Source: docs/stories/v10-j-web-wiring-core.md AC2]
 */

import { runtimeConfig } from '@runtime-config';

export type DataMode = 'live' | 'mock';

export function getDataMode(): DataMode {
  const explicit = runtimeConfig('VITE_DATA_MODE');
  if (explicit === 'live' || explicit === 'mock') return explicit;
  return import.meta.env.PROD ? 'live' : 'mock';
}

/** True when hooks should hit the real API. */
export function isLiveData(): boolean {
  return getDataMode() === 'live';
}
